// Ids of the synthetic rule sets computeEditableRuleSets builds around rules
// that aren't in a real rule group.
export const MONTHLY_EXPENSES_SET_ID = 'set-monthly-expenses';
export const UNGROUPED_GOALS_SET_ID = 'set-ungrouped-goals';
